import GeneralService from "./GeneralService";

export class SemanticService {
  public static buildSemanticComboChart(
    payload: any,
    loadingHandler: ((val: boolean) => void) | null,
    apiKey: string
  ) {
    return GeneralService.post(
      "/metadata/semantic_chart/combo",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_WEST_ENDPOINT,
      apiKey
    );
  }
}
